/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { RenderOnClient } from '@jira/ssr__ssr-toolkit/src/render-on-client.tsx';
import { LazyNotifications as Notifications } from './lazy-badge/index.tsx';

export const Badge = ({
	releaseNotesNotifications = 0,
}: {
	releaseNotesNotifications: number;
}): React.JSX.Element | null => {
	return (
		<RenderOnClient>
			{releaseNotesNotifications > 0 ? (
				<Notifications max={3} appearance="primary">
					{releaseNotesNotifications}
				</Notifications>
			) : null}
		</RenderOnClient>
	);
};
